module.exports = __webpack_public_path__ + "static/img/289.51f5732.png";